export default __webpack_public_path__ + "assets/images/Real-Time-Payouts-336e6bbba53628fa5bfd9b55f9a4a7bb.svg";